import { FC, PropsWithChildren, useEffect, useMemo } from "react";
import TagManager from "react-gtm-module";

import useIsNativeApp from "web/hooks/useIsNativeApp";
import { nativeGTMKey } from "web/constants/native";
import Loading from "../Common/LoadingNew";
import getRedirectData from "./utils/getRedirectData";

const REDIRECT_DELAY = 3000;

const RedirectToNativeStore: FC<PropsWithChildren> = ({ children }) => {
  const { willRedirectToStore, url } = useMemo(getRedirectData, []);
  const isNativeApp = useIsNativeApp();

  useEffect(() => {
    if (!url) {
      return undefined;
    }

    if (willRedirectToStore) {
      const gtmKey = isNativeApp ? nativeGTMKey : process.env.WEB_GTM_API_KEY;
      if (TagManager && gtmKey) {
        TagManager.initialize({
          gtmId: gtmKey as string,
        });
      }
  
      const timeoutId = window.setTimeout(() => {
        window.location.href = url as string;
      }, REDIRECT_DELAY);

      return () => window.clearTimeout(timeoutId);
    }

    window.location.href = url;
    return undefined;
  }, [url, willRedirectToStore, TagManager, isNativeApp]);

  if (!willRedirectToStore && !url) {
    return <>{children}</>;
  }

  if (willRedirectToStore) {
    return <Loading />;
  }

  return null;
};

export default RedirectToNativeStore;
